/**
 * Starts the trial period flow for a TEST user.
 * @param {Object} options - Additional options for `useMutation`.
 * @returns {Object} - Mutation result. Call `mutate()` or `mutateAsync()` without variables.
 * Important details:
 * On success this hook invalidates the `ME` query so the authenticated user data is refreshed.
 */

import { useMutation } from '@tanstack/react-query'
import { authMutationKeys, authQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'
import api from '../../config/axios-config'

export const useStartTrialMutation = (options) => {
  const handleMutation = async () => {
    const config = {
      method: 'post'
    }

    const { data } = await api('/api/v2/me/testPhase', config)

    return data
  }

  const mergedOptions = { ...options }
  const customOnSuccess = options?.onSuccess

  delete mergedOptions.onSuccess

  return useMutation({
    mutationKey: [authMutationKeys.START_TRIAL_MUTATION],
    mutationFn: handleMutation,
    retry: false,
    onSuccess: (data, variables, context) => {
      customQueryClient.invalidateQueries({
        queryKey: [authQueryKeys.ME]
      })

      customQueryClient.invalidateQueries({
        queryKey: [authQueryKeys.SUBSCRIPTION_INFO]
      })

      customOnSuccess?.(data, variables, context)
    },
    ...mergedOptions
  })
}
